"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Shimmer = require("./Shimmer");
Object.keys(_Shimmer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Shimmer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Shimmer[key];
    }
  });
});